import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { MapOptions } from '../../../utils/models/map-options';
import { customColorSets } from '../../../utils/custom-color-sets';

@Component({
    selector: 'neu-charts-heat',
    template: `<div class="chart-container" *ngIf="data && (data.length > 0)">
    <ngx-charts-heat-map
        [scheme]="colorScheme"
        [results]="data"
        [legend]="options.showLegend"
        [gradient]="gradient"
        [xAxis]="options.showXAxis"
        [yAxis]="options.showYAxis"
        [showXAxisLabel]="options.showXAxisLabel"
        [showYAxisLabel]="options.showYAxisLabel"
        [xAxisLabel]="options.xAxisLabel"
        [yAxisLabel]="options.yAxisLabel"
        [innerPadding]="options.innerPadding"
        (select)="mSelectedEvent($event)">
    </ngx-charts-heat-map>
</div>
<no-data *ngIf="(!data) || (data.length <= 0)"></no-data>`,
    styles: [``]
})
export class HeatComponent implements OnInit {

    @Input('data') data: any;
    @Input('options') customOptions: MapOptions;

    @Output() onSelect: EventEmitter<any> = new EventEmitter<any>();

    options: MapOptions = new MapOptions();

    colorScheme: any;

    constructor() { }

    ngOnInit() { }

    ngOnChanges(changes: SimpleChanges) {
        Object.assign(this.options, this.customOptions);

        if(this.options.colorScheme != null) {
            this.colorScheme = {};
            this.colorScheme['domain'] = this.options.colorScheme;
        } else {
            this.colorScheme = customColorSets.find(s => s.name == 'palatte');
        }
        if (this.options.showSkew && (changes.customOptions.previousValue != changes.customOptions.currentValue)) {
            this.data.sort((current, next) => {
                if (current.series.length > next.series.length) {
                    return -1;
                } else if (current.series.length < next.series.length) {
                    return 1;
                }
                return 0;
            });
        }
    }

    mSelectedEvent(event: any) {
        this.onSelect.emit(event);
    }

}
